<div class="el-page">

  <!-- Page header -->
  <div class="el-page-header">
    <div class="el-page-header__left">
      <div class="el-page-header__icon">
        <mat-icon>people</mat-icon>
      </div>
      <div>
        <h1 class="el-page-header__title">Empleados</h1>
        <p class="el-page-header__sub">Gestión del equipo y control de acceso</p>
      </div>
    </div>
    <div class="el-page-header__actions" *ngIf="selectedTab === 0">
      <mat-checkbox [(ngModel)]="hideInactive" (change)="toggleHideInactive()" class="el-filter-check">
        Ocultar inactivos
      </mat-checkbox>
      <button mat-stroked-button class="el-btn-sync" (click)="bulkSync()" title="Sincronizar todos con Bookcit">
        <mat-icon>sync</mat-icon> Sincronizar Bookcit
      </button>
      <button mat-flat-button class="el-btn-add" (click)="create(null)">
        <mat-icon>person_add</mat-icon> Nuevo empleado
      </button>
      <app-help key="Personal1"></app-help>
    </div>
  </div>

  <!-- Tabs -->
  <mat-tab-group (selectedIndexChange)="selectedTab = $event" class="el-tabs">

    <!-- Tab: Personal -->
    <mat-tab label="Personal">
      <ng-template matTabContent>

        <!-- Loading splash -->
        <div class="el-loading" *ngIf="!ready">
          <div class="el-loading__icon-wrap">
            <mat-icon>people</mat-icon>
          </div>
          <div class="el-loading__dots"><span></span><span></span><span></span></div>
          <p class="el-loading__text">Cargando empleados…</p>
        </div>

        <ng-container *ngIf="ready">

          <!-- Tabla -->
          <div class="el-table-wrap" *ngIf="!empty">
            <ng-container *ngIf="showTable">
              <app-table
                [columns]="displayColumns"
                [dataSource]="filteredDataSource"
                [hasHeaderActions]="false"
                [hasSelect]="false"
                [hasButton]="true"
                [actionsTemplate]="actionsButtons"
                [hasFilterOldObservable]="true">
              </app-table>
            </ng-container>
          </div>

          <!-- Estado vacío -->
          <div class="cf-empty-state" *ngIf="empty">
            <mat-icon>people_outline</mat-icon>
            <p class="cf-empty-state__title">Sin empleados</p>
            <p class="cf-empty-state__subtitle">
              {{ hideInactive ? 'No hay empleados activos. Prueba a mostrar los inactivos.' : 'Comienza añadiendo el primer empleado.' }}
            </p>
            <button mat-flat-button class="el-btn-add" (click)="create(null)">
              <mat-icon>person_add</mat-icon> Nuevo empleado
            </button>
          </div>

        </ng-container>

      </ng-template>
    </mat-tab>

    <!-- Tab: Calendario -->
    <mat-tab label="Calendario">
      <ng-template matTabContent>
        <app-turnos-calendario></app-turnos-calendario>
      </ng-template>
    </mat-tab>

  </mat-tab-group>

  <!-- Menú de acciones por fila -->
  <ng-template #actionsButtons let-uid="uid">
    <button mat-menu-item (click)="edit(uid)">
      <mat-icon>edit</mat-icon><span>Editar</span>
    </button>
    <button mat-menu-item *ngIf="isEmployeeActive(uid)" (click)="activeAccess(uid)">
      <mat-icon>vpn_key</mat-icon><span>Configurar acceso</span>
    </button>
    <button mat-menu-item (click)="syncBooking(uid)">
      <mat-icon>sync</mat-icon><span>Sincronizar con Bookcit</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item class="el-action-danger" (click)="delete(uid)">
      <mat-icon>delete</mat-icon><span>Borrar</span>
    </button>
  </ng-template>

</div>
